import * as R from "ramda";
import { DEFAULT_FORMATS, URN_FORMAT, FILE_FORMAT, ZIP_FORMAT } from "./constants/headers.mjs";
const getSdmxFormat = ({
  asFile,
  asZip,
  datasource,
  format,
  labels,
  type,
  withUrn = true
}) => {
  const formats = R.pipe(
    R.propOr({}, "headers"),
    R.mergeDeepRight(DEFAULT_FORMATS)
  )(datasource);
  const getFormat = R.ifElse(R.has(format), R.prop(format), R.prop("json"));
  const typeFormats = R.ifElse(
    R.equals("data"),
    R.identity,
    R.always("structure")
  )(type);
  const defaultFormat = getFormat(R.prop(typeFormats, formats));
  const sdmxFormat = R.pathOr(
    defaultFormat,
    ["headers", typeFormats, format],
    datasource
  );
  return R.pipe(
    R.when(R.always(!!withUrn), R.append(URN_FORMAT)),
    R.when(R.always(!!asFile), R.append(FILE_FORMAT)),
    R.when(R.always(!!asZip), R.append(ZIP_FORMAT)),
    R.when(
      R.always(typeFormats === "data" && format === "csv"),
      R.append(R.defaultTo("labels=code", labels))
    ),
    R.join(";")
  )([sdmxFormat]);
};
export {
  getSdmxFormat
};
